import { render, staticRenderFns } from "./UsePotentialSelect.vue?vue&type=template&id=7988a914&"
import script from "./UsePotentialSelect.vue?vue&type=script&lang=js&"
export * from "./UsePotentialSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports